import React from "react";
import "./Header.css";
import TrustpilotRating from "../../shared-components/TrustpilotRating/TrustpilotRating";
import { useBrand } from "../../../hooks/useBrand";
import { BRAND_IDS } from "../../../config/brands";

export default function Header({ hideRating = false }) {
  const brand = useBrand();

  // Add brand-specific class for MLM
  const logoClass = brand.id === BRAND_IDS.MLM ? 'logo-text logo-mlm' : 'logo-text';

  return (
    <div className="header-wrapper" style={{
      paddingTop: '0px',
      paddingBottom: '0px'
    }}>
      <div className="container">
        <div className="row g-0">
          <div className="site-logo d-flex flex-column align-items-center gap-3">
            <img
              src={brand.logo}
              alt={`${brand.displayName} logo`}
              className={logoClass}
            />
            {!hideRating && <TrustpilotRating />}
          </div>
        </div>
      </div>
    </div>
  );
}
